<template>
  <v-flex v-if="mission" class="mission-page">
    <v-layout
      v-if="missionState && missionState.infosPanelVisible"
      :style="{ flexGrow: 0, flexShrink: 0, position: 'relative' }"
      class="ma-2 my-3 pa-2 py-3 mission-infos mission-resume elevation-2"
    >
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.GliderStatus') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ $t(`GliderWaitingMode.${mission.gliderWaitingMode}`) }}</span>
      </v-flex>
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.StartDate') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ firstYo.yoGpsDatTime | formatDate('DD/MM/YYYY') }}</span>
      </v-flex>
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.EndDate') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">
          {{
            mission.misActifOn
              ? $t('Pilot.MissionInfos.OnGoing')
              : $options.filters.formatDate(lastYo.yoGpsDatTime, 'DD/MM/YYYY')
          }}
        </span>
      </v-flex>
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.MissionDuration') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ [firstYo.yoGpsDatTime, lastYo.yoGpsDatTime] | formatDuree($i18n) }}</span>
      </v-flex>
      <v-flex class="inline-block xs5 sm3 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.DistanceTraveled') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ distanceTravelled | formatDistance }}</span>
      </v-flex>
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.LastConnect') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ lastYo.yoGpsDatTime | formatDate }}</span>
      </v-flex>
      <v-flex class="inline-block xs4 sm2 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.LastCycle') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ lastYo.yosCycle }}</span>
      </v-flex>
      <v-flex class="inline-block xs4 sm3 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.LastPosition') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">
          {{ this.$options.filters[this.coordFormatFilter]([lastYo.yoGpsLon, this.lastYo.yoGpsLat]) }}
        </span>
      </v-flex>
      <v-flex class="inline-block xs5 sm3 text-xs-center" style="min-width: min-content">
        <strong>{{ $t('Pilot.MissionInfos.BatteryLevel') }}</strong>
        <br class="hidden-sm-and-down" />
        <span class="data">{{ lastYo.batteries }}</span>
        <div class="pl-2 relative w-6 h-6 inline-block">
          <v-icon class="absolute left-0 top-0" :style="{ color: batteryColor }" v-text="batteryIcon"></v-icon>
          <v-icon class="absolute left-0 top-0" :style="{ color: '#000000' }">mdi-battery-outline</v-icon>
        </div>
      </v-flex>
      <v-btn
        small
        class="btnClose"
        icon
        @click.prevent="hideInfos"
        :title="$t('Pilot.MissionInfos.HideInfosPanelTooltip')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-layout>
    <multipane
      :class="{ 'mt-2': !(missionState && missionState.infosPanelVisible) }"
      :style="{ flexGrow: 1 }"
      class="custom-resizer mb-2"
      @paneResizeStop="panResized"
      layout="vertical"
    >
      <mission-detail
        :isleft="true"
        class="mission-infos border-box elevation-2 ml-2"
        :class="{ transition: isTransitionActive }"
        :style="{ width: currentDetailMission.leftPanelWidth, flex: '0 0 auto' }"
      />
      <multipane-resizer class="pa-1">
        <v-btn
          @click="resizePaneLeft('0px')"
          icon
          class="toggle-left"
          :title="$t('Pilot.MissionInfos.ExpandRightPanelTooltip')"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <br />
        <v-btn
          @click="resizePaneLeft('50%')"
          icon
          class="toggle-left"
          :title="$t('Pilot.MissionInfos.EqualRightLeftPanelTooltip')"
        >
          ||
        </v-btn>
        <br />
        <v-btn
          @click="resizePaneLeft('calc(100% - 22px)')"
          icon
          class="toggle-right"
          :title="$t('Pilot.MissionInfos.ExpandLeftPanelTooltip')"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </multipane-resizer>
      <mission-detail
        :isleft="false"
        class="mission-infos border-box elevation-2 mr-2"
        style="flex: 1 1 auto; overflow: auto"
      />
    </multipane>
  </v-flex>
</template>
<script>
import { mapGetters } from 'vuex'
import MissionDetail from '@/components/mission/MissionDetail'
import Multipane from '@/components/shared/multipane/multipane'
import MultipaneResizer from '@/components/shared/multipane/multipane-resizer'
import { AloYo } from '@/models/alo/AloYo'
import distance from '@turf/distance'
import { point } from '@turf/helpers'
import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
export default {
  name: 'MissionPage',
  components: { MissionDetail, Multipane, MultipaneResizer },
  props: {
    missionid: Number,
  },
  data() {
    return {
      isTransitionActive: false,
    }
  },
  computed: {
    ...mapGetters(['currentDetailMission', 'coordFormatFilter', 'isDrawerOpen', 'isRightDrawerOpen', 'uistatebyuiid']),
    showDrawer: {
      get() {
        return this.isDrawerOpen
      },
      set(newValue) {
        this.$store.myActions.UI_SET_DRAWER_VISIBILITY(newValue)
      },
    },
    showRightDrawer: {
      get() {
        return this.isRightDrawerOpen
      },
      set(newValue) {
        this.$store.myActions.UI_SET_RIGHT_DRAWER_VISIBILITY(newValue)
      },
    },
    mission() {
      return this.currentDetailMission && this.currentDetailMission.mission
    },
    mission_uiid() {
      return buildMissionUIStateId(this.mission.misId, 'detail')
    },
    //recupere le state de travail
    missionState() {
      //retourne un MapUiState
      return this.uistatebyuiid(this.mission_uiid)
    },
    clipped() {
      return this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm'
    },
    firstYo() {
      let yo = null
      var idx = 0
      while (this.mission.yoArray.length > idx && (yo = this.mission.yoArray[idx]).isUnderWater) {
        idx++
      }
      if (yo && !yo.isUnderWater) return yo
      return null
    },
    lastYo() {
      let yo = null
      var idx = this.mission.yoArray.length - 1
      while (idx >= 0 && (yo = this.mission.yoArray[idx]).isUnderWater) {
        idx--
      }
      if (yo && !yo.isUnderWater) return yo
      return null
    },
    /*firstYo() {        
        return this.mission.yoArray.length > 0?this.mission.yoArray[0]:new AloYo()
      },
      lastYo() {
        return this.mission.yoArray.length > 0?this.mission.yoArray[this.mission.yoArray.length -1]:new AloYo()
      },*/
    batteryColor() {
      if (parseFloat(this.lastYo.batteries) > 27.8) return '#3fe7f0'
      else if (parseFloat(this.lastYo.batteries) > 26.1) return '#28dd2e'
      else if (parseFloat(this.lastYo.batteries) > 24.5) return '#fed403'
      else if (parseFloat(this.lastYo.batteries) > 23.8) return '#ff821c'
      else return '#fe1b22'
    },
    batteryIcon() {
      if (parseFloat(this.lastYo.batteries) > 27.8) return 'mdi-battery'
      else if (parseFloat(this.lastYo.batteries) > 26.1) return 'mdi-battery-70'
      else if (parseFloat(this.lastYo.batteries) > 24.5) return 'mdi-battery-50'
      else if (parseFloat(this.lastYo.batteries) > 23.8) return 'mdi-battery-30'
      else return 'mdi-battery-10'
    },
    distanceTravelled() {
      //Attention a prendre en compte le drift eventuellement ?
      let prevYo = null
      return this.mission.yoArray
        .reduce((total, yo) => {
          if (
            prevYo &&
            !prevYo.isUnderWater &&
            !yo.isUnderWater &&
            prevYo.yoGpsLon &&
            prevYo.yoGpsLat &&
            yo.yoGpsLon &&
            yo.yoGpsLat
          ) {
            const dist =
              total +
              Math.abs(
                distance(
                  point([prevYo.yoGpsLon, prevYo.yoGpsLat]),
                  point([(yo.driftArray[0] || yo).yoGpsLon, (yo.driftArray[0] || yo).yoGpsLat]),
                ) * 1000,
              )
            prevYo = yo
            return dist
          } else {
            if (!prevYo && !yo.isUnderWater && yo.yoGpsLon && yo.yoGpsLat) prevYo = yo
            return total
          }
        }, 0)
        .toFixed(0)
    },
  },
  watch: {
    $route(to, from) {
      this.$store.myActions.MISSION_SELECT_DETAIL_REQUEST(this.missionid)
    },
  },
  async created() {
    await this.$store.myActions.MISSION_SELECT_DETAIL_REQUEST(this.missionid)
  },
  methods: {
    resizePaneLeft(size) {
      //force la transition
      this.isTransitionActive = true
      this.$store.myActions.MISSION_SET_LEFTPANEL_SIZE(size)
      //desactive la transition
      setTimeout(() => {
        this.isTransitionActive = false
      }, 250)
    },
    panResized(pane, resizer, size) {
      this.$store.myActions.MISSION_SET_LEFTPANEL_SIZE(size)
    },
    toggleRightDrawer() {
      if (this.clipped) this.showDrawer = false
      this.showRightDrawer = !this.showRightDrawer
    },
    hideInfos() {
      if (this.missionState.infosPanelVisible)
        this.$store.myActions.UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY(this.mission_uiid)
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnClose {
  position: sticky;
  top: 0px;
  right: 0px;
  background: #ddd;
}
.data {
  color: var(--primary-color);
  padding: 0 10px;
}
.toggle-left,
.toggle-right {
  left: 0px;
  margin: 0px;
  padding: 0px;
  max-width: 100%;
  position: relative;
}

.transition {
  transition: all 250ms ease;
}

.mission-page {
  background-color: #ddd;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.mission-infos {
  background-color: #f4f4f4;
}

.mission-resume {
  white-space: nowrap;
  overflow-x: auto;
}
</style>

<style lang="scss">
.custom-resizer > .multipane-resizer {
  flex-grow: 1;
  height: auto;
  margin: 0;
  left: 0;
  min-width: 15px;
  max-width: 15px;
  position: relative;
  &:before {
    display: block;
    content: '';
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
</style>
